<app-browser-detect></app-browser-detect>

<header class="main-header d-flex justify-content-between align-items-center">
  <div>
    @if (!isInEdition) {
      <a class="btn" href="/plan/{{plan?.id}}" routerLink="/plan/{{plan?.id}}">
        <b><i class="bi bi-arrow-left-short"></i></b>
      </a>
    } @else {
      <a (click)="isInEdition = false" class="btn" href="javascript:void(0)">
        <b><i class="bi bi-arrow-left-short"></i></b>
      </a>
    }
  </div>

  @if (!isInEdition) {
    <b>Gestion des cartes</b>
  } @else {
    <b><span class="color-grey">Gestion des cartes</span> : Fond de carte</b>
  }


  <div class="d-flex justify-content-end me-2">
    <app-steps [type]="'map'"></app-steps>
  </div>
</header>

<div class="page-map">
  <div class="page-map-panel bg-white">
    <div class="pm-panel d-flex justify-content-between flex-column h-100">
      <div class="pm-panel-content">
        <div class="m-3">
          @if (!isInEdition) {
            <app-collapse name="Fond de carte">

              <div  *ngIf="!!plan && mainSnapshot">

                <div class="pm-zoom mt-3 mb-3" highlightOnOver=".highlight-2d-print">
                  <span class="pm-zoom-name">Fond de carte
                    <span *ngIf="mainSnapshot.is_custom_upload" > - Personnalisé</span>
                  </span>

                  <button (click)="isInEdition = true"
                          *ngIf="!mainSnapshot.is_custom_upload"
                          [disabled]="isLoadingLayer"
                          [matTooltip]="'Éditer'"
                          class="pm-btn mt-2 me-2"
                          matTooltipPosition="above">
                    <i class="bi bi-pen"></i>
                  </button>

                  <button (click)="deleteZoom('MAIN')" [disabled]="isLoadingLayer" [matTooltip]="'Supprimer'" class="pm-btn mt-2 me-2" matTooltipPosition="above">
                    <i class="bi bi-trash"></i>
                  </button>

                  <a [href]="mainSnapshot.snapshot_url_image" [matTooltip]="'Télécharger'" class="d-inline-block pm-btn mt-2 me-2" download="test" matTooltipPosition="above" target="_blank">
                    <i class="bi bi-download"></i>
                  </a>
                </div>
              </div>

              <div *ngIf="!!plan && !mainSnapshot">

                <div class="text-center mb-2" >
                  <button (click)="isInEdition = true" class="pm-btn mt-3">
                    Generer une vue 2d
                  </button>

                  <button (click)="inputFileBackground.click()" class="pm-btn mt-3">
                    Uploader un fond de carte personnalisé
                  </button>
                </div>
                <i>le ratio recommandé est 1:1.357</i>
              </div>
              <input  #inputFileBackground (change)="onFileSelected($event, 'background')" id="formFileBackground" style="display: none" type="file">
            </app-collapse>

            <app-collapse name="Custom module">

              @for (custumModule of listModule | filterBy: 'id_module' : ModuleType.MODULE_CUSTOM
                ; track custumModule.id
                ; let idx = $index
                ) {
                <div class="pm-zoom mt-3 mb-3" highlightOnOver=".highlight-custom-{{custumModule.id}}">
                  <span class="pm-zoom-name">Bloc personnalisé n°{{idx+1}}</span>

                  <button (click)="deleteCustomModule(custumModule)"
                          [matTooltip]="'Supprimer'"
                          class="pm-btn mt-2 me-2"
                          matTooltipPosition="above">
                    <i class="bi bi-trash"></i>
                  </button>

                  <a [href]="custumModule.url"
                     [matTooltip]="'Télécharger'"
                     class="d-inline-block pm-btn mt-2 me-2"
                     download="Bloc personnalisé n°{{idx}}"
                     matTooltipPosition="above"
                     target="_blank">
                    <i class="bi bi-download"></i>
                  </a>
                </div>
              }

              <input type="file" id="fileInput" style="display: none;" (change)="onCustomModuleUpload($event)">

              <button class="pm-btn mt-2 pointer-event" (click)="addBlock()">
                <i class="bi bi-plus-lg"></i> Ajouter un bloc personnalisé
              </button>
            </app-collapse>
          }

          @if (!isInEdition) {
            <app-collapse name="Zooms">
              @for (zoom of listZoomSnapshot; track zoom.id_zoom) {
                <div class="pm-zoom mt-3 mb-3" highlightOnOver=".highlight-zoom-{{zoom.id_zoom}}">
                  <span class="pm-zoom-name">
                    {{zoom.id_zoom | replace : '_' : ' '}}
                    @if (zoom.is_custom_upload) {
                      <span > - Personnalisé</span>
                    }
                  </span>
                  <button (click)="resetZoomPosition(zoom)" [disabled]="isLoadingLayer" [matTooltip]="'Position initiale'" class="pm-btn mt-2 me-2" matTooltipPosition="above">
                    <i class="bi bi-bootstrap-reboot"></i>
                  </button>

                  @if (!zoom.is_custom_upload) {
                    <button [disabled]="isLoadingLayer" [matTooltip]="'Éditer'" class="pm-btn mt-2 me-2" matTooltipPosition="above" routerLink="/plan/{{plan?.id}}/6/{{zoom.id_zoom}}">
                      <i class="bi bi-pen"></i>
                    </button>
                  }

                  <button (click)="deleteZoom(zoom.id_zoom)" [disabled]="isLoadingLayer" [matTooltip]="'Supprimer'" class="pm-btn mt-2 me-2" matTooltipPosition="above">
                    <i class="bi bi-trash"></i>
                  </button>

                  <a [href]="zoom.snapshot_url_image" [matTooltip]="'Télécharger'" class="d-inline-block pm-btn mt-2 me-2" download="test" matTooltipPosition="above" target="_blank">
                    <i class="bi bi-download"></i>
                  </a>
                </div>
              }

              @if (!!plan && listZoomSnapshot.length < 2) {
                <div >
                  <div class="text-center">
                    <button (click)="addZoom()" [disabled]="isLoadingLayer" class="pm-btn mt-3">
                      Generer une vue 3d
                    </button>
                    <button (click)="inputFileZoom.click()" [disabled]="isLoadingLayer" class="pm-btn mt-3">
                      Uploader un zoom personnalisé
                    </button>
                  </div>
                  <div class="m-2 mb-0">
                    <i>le ratio recommandé est 1:1</i>

                  </div>
                  <input  #inputFileZoom (change)="onFileSelected($event, 'zoom')" id="formFileZoom" style="display: none" type="file">
                </div>
              }
            </app-collapse>

            <app-collapse name="Étiquettes">
              <div class="text-center">
                <button [disabled]="isLoadingLayer" class="pm-btn mt-2 me-2" routerLink="/plan/{{plan?.id}}/label">
                  Placer les étiquettes
                </button>
              </div>
            </app-collapse>
          }

          <app-collapse [open]="true" name="Titres" >
            <modules-title-edition #moduleTitle [listModule]="listModule" [plan]="plan"/>
          </app-collapse>

          @if (!!plan && isInEdition && mapComponent) {
            <app-collapse name="Calque du fond de carte">
              <select-map-background [map]="mapComponent"/>
            </app-collapse>

            <!-- chargement parallèle des layers -->
            <layer-multi-load />

            <app-collapse [open]="true" name="Calques">
              <layer-control></layer-control>
            </app-collapse>
          }

        </div>
      </div>

      @if (isInEdition) {
        <div class="pm-panel-actions text-center p-3">
          <button (click)="print2d()"
                  [disabled]="isLoadingLayer || isBuildingScreenShot"
                  class="pm-btn pm-btn-primary">
            Générer le fond de carte
          </button>
        </div>
      }
    </div>
  </div>
  <div class="page-map-content">
    @if (!!plan) {
      <app-map-cesium #map (isBuildingScreenShot)="isBuildingScreenShot = $event"
                      (isLoadingLayer)="isLoadingLayer = $event"
                      (screenshotEvent)="screenshotEvent($event)"
                      (whenMapIsInit)="mapIsInit()"
                      [canvasMode]="'2d'"
                      [plan]="plan"
                      [snapshot]="mainSnapshot"
                      [type]="'MAIN'">

        <!--  Gère l'affichage des modules (Zoom, Titre, Image ect...) et leur position dynamique-->
        <modules-dynamic-position [plan]="plan"
                                  [listModules]="listModule"
                                  [listZoom]="listZoomSnapshot"
                                  [listTitles]="moduleTitle.initialTitles"
                                  [map]="map">
          @if (plan?.url_labels_svg && !isInEdition) {
            <div class="reserved-area-custom-svg" [style.z-index]="ENTITY_Z_ORDER.LABEL">
              <img alt="Étiquettes" class="img-fluid"
                   src="{{plan.url_labels_svg}}?d={{timestamp}}"
                   style="position: absolute;width: 100%;height: 100%;">
            </div>
          }
        </modules-dynamic-position>



        @if (mainSnapshot?.snapshot_url_image && !isInEdition) {
          <div class="reserved-area-custom-background highlight-2d-print">
            <img alt="Fond de carte" class="img-fluid"
                 src="{{mainSnapshot.snapshot_url_image_lite || mainSnapshot.snapshot_url_image}}?d={{timestamp}}">
          </div>
        }

        @if (!isInEdition && !mainSnapshot) {
          <div class="reserved-area-custom-background highlight-2d-print" style="background-color: #c8c8c8">
            <button (click)="isInEdition = true" class="pm-btn">
              Generer une vue 2d
            </button>
          </div>
        }

      </app-map-cesium>
    }
  </div>
</div>
